<template>
  <div>
    <div class="font-weight-bold mb-1" :class="estilo.titulo">{{ titulo }}</div>
    <div v-for="(punto, i) in puntos" :key="i" class="d-flex align-start mb-1">
      <v-icon small :color="estilo.color" class="mr-2">{{ estilo.icono }}</v-icon>
      <span>{{ punto.texto }}</span>
      <v-menu
        v-if="punto.detalle || punto.ejemplo || punto.contexto"
        open-on-hover
        offset-y
        max-width="420"
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon small color="grey darken-1" class="ml-1" style="cursor: pointer;" v-bind="attrs" v-on="on">
            mdi-information-outline
          </v-icon>
        </template>
        <v-card class="pa-3">
          <div v-if="punto.detalle" class="text-body-2 mb-2">{{ punto.detalle }}</div>
          <div v-if="punto.contexto" class="text-body-2 font-weight-medium mb-1">{{ punto.contexto }}</div>
          <div v-if="punto.ejemplo" class="d-flex align-start pl-2 mb-1" :style="{ borderLeft: '3px solid ' + estilo.borde }">
            <v-icon v-if="tiposEjemplo[punto.tipo_ejemplo]" small color="grey" class="mr-1" :title="tiposEjemplo[punto.tipo_ejemplo].titulo">
              {{ tiposEjemplo[punto.tipo_ejemplo].icono }}
            </v-icon>
            <span class="text-body-2 font-italic">“{{ punto.ejemplo }}”</span>
          </div>
          <div v-if="punto.referencia" class="text-caption grey--text">{{ punto.referencia }}</div>
        </v-card>
      </v-menu>
    </div>
  </div>
</template>

<script>
const ESTILOS = {
  fortaleza: { titulo: 'green--text text--darken-2', color: 'green', icono: 'mdi-check-circle', borde: '#43A047' },
  area: { titulo: 'orange--text text--darken-2', color: 'orange', icono: 'mdi-arrow-up-bold-circle', borde: '#FB8C00' },
}

export default {
  name: 'ListaPuntosIa',

  props: {
    items: { type: Array, default: () => [] },
    tipo: { type: String, default: 'fortaleza' },
    titulo: { type: String, default: '' },
  },

  data: () => ({
    tiposEjemplo: {
      audio     : { icono: 'mdi-microphone'              , titulo: 'Audio de la vendedora' },
      texto     : { icono: 'mdi-message-text-outline'    , titulo: 'Mensaje de WhatsApp' },
      comentario: { icono: 'mdi-comment-account-outline' , titulo: 'Comentario de la supervisora' },
    },
  }),

  computed: {
    estilo () {
      return ESTILOS[this.tipo] || ESTILOS.fortaleza
    },

    // Los resúmenes anteriores guardaban solo el texto.
    puntos () {
      return (this.items || []).map(p => typeof p === 'string' ? { texto: p } : p)
    },
  },
}
</script>
